(() => {
  // OPTIONAL: cursor bit (safe to keep)
  const cc = getComputedStyle(document.body).getPropertyValue('--custom-cursor').trim();
  if (cc) document.documentElement.style.cursor = `url("${cc}"), auto`;

  const musicContainer = document.querySelector('.music-container');
  if (!musicContainer || musicContainer.classList.contains('disable-music')) return;

  // Scope everything to the container
  const playBtn  = musicContainer.querySelector('#play');
  const audio    = musicContainer.querySelector('#audio');
  const progress = musicContainer.querySelector('.progress');
  const progressContainer = musicContainer.querySelector('.progress-container');

  // Accept multiple possible cover elements/selectors
  const cover = musicContainer.querySelector('#cover, .cover, .disk');

  // ---- Robust URL resolution ----
  const getFirst = (el, names) => {
    for (const name of names) {
      // try dataset (camelCase) and raw attribute (kebab-case)
      const dsKey = name.replace(/^data-/, '').replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      const v1 = el.dataset?.[dsKey];
      if (v1) return v1;
      const v2 = el.getAttribute(name);
      if (v2) return v2;
    }
    return null;
  };

  // File URL can come from data-file-url, data-audio-url, etc.
  const fileUrl = getFirst(musicContainer, [
    'data-file-url', 'data-audio-url', 'file-url', 'audio-url'
  ]);

  // Cover can come from several places; also try existing <img> attributes
  let musicImgUrl = getFirst(musicContainer, [
    'data-music-image-url', 'data-cover-url', 'data-cover', 'music-image-url', 'cover-url'
  ]) || getFirst(cover || musicContainer, ['data-src', 'data-original', 'src']);

  // Log what we found (helps you see the culprit)
  console.log('[RADAR player]', { fileUrl, musicImgUrl, hasCoverEl: !!cover });

  if (!audio || !playBtn) return;

  // Mobile/iOS friendly
  audio.setAttribute('playsinline', '');
  audio.setAttribute('webkit-playsinline', '');
  audio.preload = 'none';

  function setIcon(isPlaying){
    const ico = playBtn.querySelector('i.fas, i.fa');
    if (!ico) return;
    ico.classList.toggle('fa-play', !isPlaying);
    ico.classList.toggle('fa-pause', isPlaying);
  }

  function setState(isPlaying){
    musicContainer.classList.toggle('play', isPlaying); // your CSS spins disk on .play
    setIcon(isPlaying);
    localStorage.setItem('audioIsPaused', String(!isPlaying));
  }

  function setCover(url){
    if (!cover || !url) return;

    // If it's an <img>, kill lazy-load attributes that block rendering
    if (cover.tagName && cover.tagName.toLowerCase() === 'img') {
      cover.removeAttribute('srcset');
      cover.removeAttribute('data-srcset');
      cover.removeAttribute('data-src');
      cover.classList?.remove('lazyload','lazy','lazysizes');
      cover.loading = 'eager';
      cover.decoding = 'async';
      cover.src = url;
    }

    // Always set background-image too (covers the <div> case and is harmless on <img>)
    cover.style.backgroundImage = `url("${url}")`;
    cover.style.backgroundSize = 'cover';
    cover.style.backgroundPosition = 'center';
    cover.style.backgroundRepeat = 'no-repeat';
  }

  function loadSong(){
    if (fileUrl) audio.src = fileUrl;
    setCover(musicImgUrl);

    const saved = parseFloat(localStorage.getItem('audioTime') || '0');
    if (!Number.isNaN(saved)) audio.currentTime = saved;
    // we only start after a gesture to satisfy mobile autoplay policies
  }

  async function playSong(){
    try {
      audio.muted = false; // ensure sound on user tap
      await audio.play();
      setState(true);
    } catch (e) {
      setState(false);
      console.warn('Audio play blocked (needs gesture):', e);
    }
  }
  function pauseSong(){ audio.pause(); setState(false); }

  // Events
  playBtn.addEventListener('click', () => (audio.paused ? playSong() : pauseSong()));

  audio.addEventListener('timeupdate', () => {
    localStorage.setItem('audioTime', String(audio.currentTime));
    if (progress && audio.duration) {
      progress.style.width = `${(audio.currentTime / audio.duration) * 100}%`;
    }
  });

  if (progressContainer) {
    progressContainer.addEventListener('click', (e) => {
      if (!audio.duration) return;
      const r = progressContainer.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      audio.currentTime = ratio * audio.duration;
    });
  }

  // Resume on first interaction if it was previously playing
  const wasPlaying = localStorage.getItem('audioIsPaused') === 'false';
  const resumeIfNeeded = () => {
    if (wasPlaying && audio.paused) playSong();
    window.removeEventListener('click', resumeIfNeeded);
    window.removeEventListener('touchstart', resumeIfNeeded);
  };
  window.addEventListener('click', resumeIfNeeded, { passive: true });
  window.addEventListener('touchstart', resumeIfNeeded, { passive: true });

  loadSong();
})();
